import PropTypes from "prop-types";

import { RS } from "../../../../data/strings/global";
import * as SC from "../../../../data/strings/PIStringConst";

import * as Theme from "../../../../app/Theme";

import TSlideDrawer from "../../../common/TSlideDrawer";
import PIRestartRateTable from "../../Tables/PIRestartRateTable";

const PIProgDataDefaultRestartRatesDrawer = (props) => {
  const content = <PIRestartRateTable modVarObjList={props.modVarObjList} defaultsOnly />;

  return (
    <TSlideDrawer
      anchor={"right"}
      onClose={props.onToggleShowDefaultsSlideDrawer}
      content={content}
      headerTitleStyle={{
        color: Theme.PI_SecondaryColor,
      }}
      saveButton={false}
      title={RS(SC.GB_stRestartRates)}
      width={Theme.slideDrawerLv2Width}
      level={2}
    />
  );
};

PIProgDataDefaultRestartRatesDrawer.propTypes = {
  modVarObjList: PropTypes.array.isRequired,
  onToggleShowDefaultsSlideDrawer: PropTypes.func,
};

PIProgDataDefaultRestartRatesDrawer.defaultProps = {
  onToggleShowDefaultsSlideDrawer: () => console.log("onToggleShowDefaultsSlideDrawer"),
};

export default PIProgDataDefaultRestartRatesDrawer;
